import { useCallback } from 'react'
import {
  DeleteDocumentRequest,
  GetDocumentGroupRequest,
  GetDocumentGroupResponse,
  UploadDocumentRequest,
} from '@trustero/trustero-api-web/lib/documentgroup/documentgroup_pb'
import { DocumentGroupServicePromiseClient } from '@trustero/trustero-api-web/lib/documentgroup/documentgroup_grpc_web_pb'
import { useSwrImmutableGrpc } from 'src/components/async/useSwrImmutableGrpc'
import { GrpcResponse, NewGrpcResponse } from 'src/components/async/hooks/types'
import { useAuthorizedGrpcClient } from 'src/adapter'
import { getBytesPayload } from 'src/Utils/File/file'

export const useGetDocumentGroup =
  (): GrpcResponse<GetDocumentGroupResponse> => {
    const request = new GetDocumentGroupRequest()

    const { response } = useSwrImmutableGrpc(
      DocumentGroupServicePromiseClient.prototype.getDocumentGroup,
      request,
      true,
    )

    return NewGrpcResponse(response)
  }

export const useGetSupportKbDocumentGroup =
  (): GrpcResponse<GetDocumentGroupResponse> => {
    const request = new GetDocumentGroupRequest()
    request.setName('Support KB')

    const { response } = useSwrImmutableGrpc(
      DocumentGroupServicePromiseClient.prototype.getDocumentGroup,
      request,
      true,
    )

    return NewGrpcResponse(response)
  }

export type UseUploadDocumentProps = {
  file: File
  groupName?: string
}

export const useUploadDocument = (): ((
  props: UseUploadDocumentProps,
) => Promise<void>) => {
  const client = useAuthorizedGrpcClient(DocumentGroupServicePromiseClient)

  return useCallback(
    async ({ file, groupName }: UseUploadDocumentProps) => {
      const request = new UploadDocumentRequest()
      request.setFileName(file.name)
      request.setMimeType(file.type)
      if (groupName) {
        request.setGroupName(groupName)
      }
      const bytes = await getBytesPayload(file)
      request.setFile(bytes)
      await client.uploadDocument(request)
    },
    [client],
  )
}

export type UseDeleteDocumentProps = {
  documentId: string
}

export const useDeleteDocument = (): ((
  props: UseDeleteDocumentProps,
) => Promise<void>) => {
  const client = useAuthorizedGrpcClient(DocumentGroupServicePromiseClient)

  return useCallback(
    async ({ documentId }: UseDeleteDocumentProps) => {
      const request = new DeleteDocumentRequest()
      request.setDocumentId(documentId)
      await client.deleteDocument(request)
    },
    [client],
  )
}
